// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   INTERVIEW ORCHESTRATOR - G42 BRANDING
   ========================================== */

.interview-loading-container {
  min-height: 100vh;
  background: var(--interview-bg-main);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--interview-space-3xl) var(--interview-space-lg);
  font-family: var(--interview-font-primary);
}

.interview-loading-card {
  background: var(--interview-bg-white);
  border-radius: var(--interview-radius-3xl);
  padding: var(--interview-space-4xl);
  box-shadow: var(--interview-shadow-card);
  max-width: var(--interview-container-sm);
  width: 100%;
  text-align: center;
}

.interview-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--interview-border-default);
  border-top-color: var(--interview-brand-primary);
  border-radius: var(--interview-radius-circle);
  animation: interview-spin 0.8s linear infinite;
  margin: 0 auto var(--interview-space-2xl);
}

@keyframes interview-spin {
  to {
    transform: rotate(360deg);
  }
}

.interview-loading-text {
  font-size: var(--interview-text-base);
  color: var(--interview-text-muted);
  margin: 0;
  font-weight: var(--interview-text-medium);
  line-height: 1.5;
}

.interview-error-container {
  min-height: 100vh;
  background: var(--interview-bg-main);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--interview-space-3xl) var(--interview-space-lg);
  font-family: var(--interview-font-primary);
}

.interview-error-card {
  background: var(--interview-bg-white);
  border-radius: var(--interview-radius-3xl);
  padding: var(--interview-space-4xl);
  box-shadow: var(--interview-shadow-card);
  max-width: var(--interview-container-sm);
  width: 100%;
  text-align: center;
}

.interview-error-icon {
  font-size: 48px;
  margin-bottom: var(--interview-space-lg);
}

.interview-error-title {
  font-size: var(--interview-text-xl);
  font-weight: var(--interview-text-bold);
  color: var(--interview-text-primary);
  margin: 0 0 var(--interview-space-sm) 0;
  letter-spacing: -0.02em;
  line-height: 1.3;
}

.interview-error-message {
  font-size: var(--interview-text-base);
  color: var(--interview-text-muted);
  margin: 0;
  line-height: 1.6;
}

.interview-error-link {
  color: var(--interview-brand-primary);
  text-decoration: none;
  font-weight: var(--interview-text-semibold);
  transition: all var(--interview-transition-base);
}

.interview-error-link:hover {
  color: var(--interview-brand-primary-dark);
  text-decoration: underline;
}

.interview-proficiency-container {
  min-height: 100vh;
  background: var(--interview-bg-main);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--interview-space-3xl) var(--interview-space-lg);
  font-family: var(--interview-font-primary);
}

.interview-proficiency-panel {
  width: min(640px, 100%);
  background: var(--interview-bg-white);
  border: 1px solid var(--interview-border-default);
  border-radius: var(--interview-radius-2xl);
  box-shadow: var(--interview-shadow-card);
  padding: var(--interview-space-4xl);
}

.interview-proficiency-kicker {
  margin: 0 0 var(--interview-space-sm);
  color: var(--interview-brand-primary);
  font-size: var(--interview-text-sm);
  font-weight: var(--interview-text-bold);
  text-transform: uppercase;
}

.interview-proficiency-title {
  margin: 0 0 var(--interview-space-2xl);
  color: var(--interview-text-primary);
  font-size: var(--interview-text-2xl);
  line-height: 1.2;
}

.interview-proficiency-options {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: var(--interview-space-md);
  margin-bottom: var(--interview-space-2xl);
}

.interview-proficiency-option-wrapper {
  position: relative;
}

.interview-proficiency-option {
  width: 100%;
  min-height: 96px;
  border: 1px solid var(--interview-border-default);
  border-radius: var(--interview-radius-lg);
  background: var(--interview-bg-white);
  color: var(--interview-text-primary);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--interview-space-xs);
  transition: border-color var(--interview-transition-base), box-shadow var(--interview-transition-base),
    transform var(--interview-transition-base);
}

.interview-proficiency-option:hover {
  transform: translateY(-2px);
  border-color: var(--interview-brand-primary);
  box-shadow: 0 4px 12px rgba(27, 94, 98, 0.1);
}

.interview-proficiency-option.is-selected {
  border-color: var(--interview-brand-primary);
  box-shadow: 0 0 0 3px rgba(27, 94, 98, 0.14);
}

.interview-proficiency-option.is-selected:hover {
  box-shadow: 0 0 0 3px rgba(27, 94, 98, 0.14), 0 4px 12px rgba(27, 94, 98, 0.1);
}

.interview-proficiency-number {
  font-size: var(--interview-text-2xl);
  font-weight: var(--interview-text-bold);
}

.interview-proficiency-label {
  font-size: var(--interview-text-xs);
  font-weight: var(--interview-text-semibold);
  text-align: center;
}

/* Tooltip Styles */
.interview-proficiency-tooltip {
  position: absolute;
  bottom: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  background: var(--interview-bg-white);
  border: 1px solid var(--interview-border-default);
  border-radius: var(--interview-radius-lg);
  padding: var(--interview-space-md);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
  pointer-events: none;
  z-index: 100;
  width: max-content;
  max-width: 280px;
}

.interview-proficiency-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid var(--interview-bg-white);
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.05));
}

.interview-proficiency-option-wrapper:hover .interview-proficiency-tooltip,
.interview-proficiency-option-wrapper:focus-within .interview-proficiency-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-4px);
}

.interview-proficiency-tooltip-title {
  font-size: var(--interview-text-sm);
  font-weight: var(--interview-text-bold);
  color: var(--interview-text-primary);
  margin-bottom: var(--interview-space-xs);
  white-space: nowrap;
}

.interview-proficiency-tooltip-description {
  font-size: var(--interview-text-xs);
  color: var(--interview-text-muted);
  line-height: 1.5;
}

.interview-proficiency-start {
  width: 100%;
  min-height: 48px;
  border: 0;
  border-radius: var(--interview-radius-lg);
  background: var(--interview-brand-primary);
  color: var(--interview-bg-white);
  font-size: var(--interview-text-base);
  font-weight: var(--interview-text-bold);
  cursor: pointer;
}

@media (max-width: 576px) {
  .interview-loading-card,
  .interview-error-card {
    padding: var(--interview-space-3xl) var(--interview-space-2xl);
    border-radius: var(--interview-radius-2xl);
  }

  .interview-proficiency-panel {
    padding: var(--interview-space-3xl) var(--interview-space-2xl);
  }

  .interview-proficiency-options {
    grid-template-columns: 1fr;
  }

  /* Tooltip adjustments for mobile */
  .interview-proficiency-tooltip {
    max-width: calc(100vw - 80px);
    left: 0;
    right: 0;
    margin: 0 auto;
    transform: none;
  }

  .interview-proficiency-option-wrapper:hover .interview-proficiency-tooltip,
  .interview-proficiency-option-wrapper:focus-within .interview-proficiency-tooltip {
    transform: translateY(-4px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Interview/Interview.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mCAAmC;EACnC,wCAAwC;EACxC,wCAAwC;EACxC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,gDAAgD;EAChD,6CAA6C;EAC7C,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;EACT,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mCAAmC;EACnC,wCAAwC;EACxC,wCAAwC;EACxC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,oCAAoC;EACpC,uCAAuC;EACvC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,2CAA2C;EAC3C,gDAAgD;AAClD;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,iDAAiD;EACjD,0CAA0C;EAC1C,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,mCAAmC;EACnC,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iDAAiD;EACjD,yCAAyC;EACzC,qCAAqC;EACrC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B;8CAC4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,iDAAiD;EACjD,yCAAyC;EACzC,kCAAkC;EAClC,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;EAClB,wEAAwE;EACxE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,oCAAoC;EACpC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,yCAAyC;EACzC,0CAA0C;EAC1C,gCAAgC;EAChC,qCAAqC;EACrC,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE;;IAEE,8DAA8D;IAC9D,0CAA0C;EAC5C;;EAEA;IACE,8DAA8D;EAChE;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,mCAAmC;EACnC;IACE,6BAA6B;IAC7B,OAAO;IACP,QAAQ;IACR,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ==========================================\n   INTERVIEW ORCHESTRATOR - G42 BRANDING\n   ========================================== */\n\n@import '../../styles/interview-theme.css';\n\n.interview-loading-container {\n  min-height: 100vh;\n  background: var(--interview-bg-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--interview-space-3xl) var(--interview-space-lg);\n  font-family: var(--interview-font-primary);\n}\n\n.interview-loading-card {\n  background: var(--interview-bg-white);\n  border-radius: var(--interview-radius-3xl);\n  padding: var(--interview-space-4xl);\n  box-shadow: var(--interview-shadow-card);\n  max-width: var(--interview-container-sm);\n  width: 100%;\n  text-align: center;\n}\n\n.interview-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--interview-border-default);\n  border-top-color: var(--interview-brand-primary);\n  border-radius: var(--interview-radius-circle);\n  animation: interview-spin 0.8s linear infinite;\n  margin: 0 auto var(--interview-space-2xl);\n}\n\n@keyframes interview-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.interview-loading-text {\n  font-size: var(--interview-text-base);\n  color: var(--interview-text-muted);\n  margin: 0;\n  font-weight: var(--interview-text-medium);\n  line-height: 1.5;\n}\n\n.interview-error-container {\n  min-height: 100vh;\n  background: var(--interview-bg-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--interview-space-3xl) var(--interview-space-lg);\n  font-family: var(--interview-font-primary);\n}\n\n.interview-error-card {\n  background: var(--interview-bg-white);\n  border-radius: var(--interview-radius-3xl);\n  padding: var(--interview-space-4xl);\n  box-shadow: var(--interview-shadow-card);\n  max-width: var(--interview-container-sm);\n  width: 100%;\n  text-align: center;\n}\n\n.interview-error-icon {\n  font-size: 48px;\n  margin-bottom: var(--interview-space-lg);\n}\n\n.interview-error-title {\n  font-size: var(--interview-text-xl);\n  font-weight: var(--interview-text-bold);\n  color: var(--interview-text-primary);\n  margin: 0 0 var(--interview-space-sm) 0;\n  letter-spacing: -0.02em;\n  line-height: 1.3;\n}\n\n.interview-error-message {\n  font-size: var(--interview-text-base);\n  color: var(--interview-text-muted);\n  margin: 0;\n  line-height: 1.6;\n}\n\n.interview-error-link {\n  color: var(--interview-brand-primary);\n  text-decoration: none;\n  font-weight: var(--interview-text-semibold);\n  transition: all var(--interview-transition-base);\n}\n\n.interview-error-link:hover {\n  color: var(--interview-brand-primary-dark);\n  text-decoration: underline;\n}\n\n.interview-proficiency-container {\n  min-height: 100vh;\n  background: var(--interview-bg-main);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--interview-space-3xl) var(--interview-space-lg);\n  font-family: var(--interview-font-primary);\n}\n\n.interview-proficiency-panel {\n  width: min(640px, 100%);\n  background: var(--interview-bg-white);\n  border: 1px solid var(--interview-border-default);\n  border-radius: var(--interview-radius-2xl);\n  box-shadow: var(--interview-shadow-card);\n  padding: var(--interview-space-4xl);\n}\n\n.interview-proficiency-kicker {\n  margin: 0 0 var(--interview-space-sm);\n  color: var(--interview-brand-primary);\n  font-size: var(--interview-text-sm);\n  font-weight: var(--interview-text-bold);\n  text-transform: uppercase;\n}\n\n.interview-proficiency-title {\n  margin: 0 0 var(--interview-space-2xl);\n  color: var(--interview-text-primary);\n  font-size: var(--interview-text-2xl);\n  line-height: 1.2;\n}\n\n.interview-proficiency-options {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: var(--interview-space-md);\n  margin-bottom: var(--interview-space-2xl);\n}\n\n.interview-proficiency-option-wrapper {\n  position: relative;\n}\n\n.interview-proficiency-option {\n  width: 100%;\n  min-height: 96px;\n  border: 1px solid var(--interview-border-default);\n  border-radius: var(--interview-radius-lg);\n  background: var(--interview-bg-white);\n  color: var(--interview-text-primary);\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--interview-space-xs);\n  transition: border-color var(--interview-transition-base), box-shadow var(--interview-transition-base),\n    transform var(--interview-transition-base);\n}\n\n.interview-proficiency-option:hover {\n  transform: translateY(-2px);\n  border-color: var(--interview-brand-primary);\n  box-shadow: 0 4px 12px rgba(27, 94, 98, 0.1);\n}\n\n.interview-proficiency-option.is-selected {\n  border-color: var(--interview-brand-primary);\n  box-shadow: 0 0 0 3px rgba(27, 94, 98, 0.14);\n}\n\n.interview-proficiency-option.is-selected:hover {\n  box-shadow: 0 0 0 3px rgba(27, 94, 98, 0.14), 0 4px 12px rgba(27, 94, 98, 0.1);\n}\n\n.interview-proficiency-number {\n  font-size: var(--interview-text-2xl);\n  font-weight: var(--interview-text-bold);\n}\n\n.interview-proficiency-label {\n  font-size: var(--interview-text-xs);\n  font-weight: var(--interview-text-semibold);\n  text-align: center;\n}\n\n/* Tooltip Styles */\n.interview-proficiency-tooltip {\n  position: absolute;\n  bottom: calc(100% + 12px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--interview-bg-white);\n  border: 1px solid var(--interview-border-default);\n  border-radius: var(--interview-radius-lg);\n  padding: var(--interview-space-md);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;\n  pointer-events: none;\n  z-index: 100;\n  width: max-content;\n  max-width: 280px;\n}\n\n.interview-proficiency-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid var(--interview-bg-white);\n  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.05));\n}\n\n.interview-proficiency-option-wrapper:hover .interview-proficiency-tooltip,\n.interview-proficiency-option-wrapper:focus-within .interview-proficiency-tooltip {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(-50%) translateY(-4px);\n}\n\n.interview-proficiency-tooltip-title {\n  font-size: var(--interview-text-sm);\n  font-weight: var(--interview-text-bold);\n  color: var(--interview-text-primary);\n  margin-bottom: var(--interview-space-xs);\n  white-space: nowrap;\n}\n\n.interview-proficiency-tooltip-description {\n  font-size: var(--interview-text-xs);\n  color: var(--interview-text-muted);\n  line-height: 1.5;\n}\n\n.interview-proficiency-start {\n  width: 100%;\n  min-height: 48px;\n  border: 0;\n  border-radius: var(--interview-radius-lg);\n  background: var(--interview-brand-primary);\n  color: var(--interview-bg-white);\n  font-size: var(--interview-text-base);\n  font-weight: var(--interview-text-bold);\n  cursor: pointer;\n}\n\n@media (max-width: 576px) {\n  .interview-loading-card,\n  .interview-error-card {\n    padding: var(--interview-space-3xl) var(--interview-space-2xl);\n    border-radius: var(--interview-radius-2xl);\n  }\n\n  .interview-proficiency-panel {\n    padding: var(--interview-space-3xl) var(--interview-space-2xl);\n  }\n\n  .interview-proficiency-options {\n    grid-template-columns: 1fr;\n  }\n\n  /* Tooltip adjustments for mobile */\n  .interview-proficiency-tooltip {\n    max-width: calc(100vw - 80px);\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    transform: none;\n  }\n\n  .interview-proficiency-option-wrapper:hover .interview-proficiency-tooltip,\n  .interview-proficiency-option-wrapper:focus-within .interview-proficiency-tooltip {\n    transform: translateY(-4px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
